
import React, { useState } from "react";
import {
  Button,
  FileUploadNew,
  FormFieldSet,
  Modal,
  showToast,
} from "../../../../components";
import {
  reportOptions,
} from "../../../../assets/data/fundingDashboardData";
import { usePagination } from "../../../../hooks";
import { DATE_RANGE_OPTIONS } from "../../../../assets/data/enumData";
import { getDatesByOption } from "../../../../utils/wf/date";
import { ReservedModalTable } from "./ReservedModalTable";
import axiosRequest from "../../../../redux/slices/universal/axiosService";
import { ENDPOINTS } from "../../../../redux/apiConfig";
import { dateFormator, exactUTCDate } from "../../../../utils";
import dayjs from "dayjs";

const ReservedUploadModal = ({
  onClose,
  formData,
  handleChange,
  initialFormData,
  setFormData,
  rows,
  columns,
  loginUserUiid,
  handleDashboardCalls
}) => {
  const [uploadedFileModal, setUploadedFileModal] = useState(false);
  const [rowsForParsedData, setRowsForParsedData] = useState([]);
  const [rawData, setRowsData] = useState([]);
  const [isCustomRange, setIsCustomRange] = useState(false);
  const [isPreviewCustomRange, setIsPreviewCustomRange] = useState(false);
  const [resolvedRange, setResolvedRange] = useState({ from: null, to: null });
  const [previewResolvedRange, setPreviewResolvedRange] = useState({
    from: null,
    to: null,
  });

  const handleSubmit = async () => {
    try {
      setUploadedFileModal(false);
      console.log({ rawData })
      // throw new Error("TBD");
      const reserveType = {
        "Cash": 1,
        "Buy": 2,
        "Adj": 3,
        "Rsv": 4,
        "Tfr": 5,
        "Bal": 6,
      }
      const response = await axiosRequest({
        method: "POST",
        url: ENDPOINTS.WF_REPORTS.ADD,
        data: {
          coll: "Report",
          payload: {
            title: formData?.modalReportName,
            parsedExt: 1,
            period: {
                from: dayjs.utc(formData.modalFromDate).toISOString(),
                to: dayjs.utc(formData.modalToDate).toISOString()
            },
            report: rawData?.map((row) => ({
              reserveDate: row?.date,
              reserveType: reserveType[row?.type],
              description: row?.description || "",
              descriptionHash: row?.descriptionHash || "",
              reference: row?.reference,
              invoices: row?.invoices?.map(inv => ({
                invoiceNum: inv?.invoiceNumber || "",
                reference: "",
                client: inv?.client || "",
                buyDate: inv?.buyDate || "",
                daysOpen: inv?.daysOpen,
                activityType: inv?.activityType,
                amounts: {
                  ar: inv?.ar || 0,
                  advance: inv?.advance || 0,
                  fee: inv?.fee || 0,
                  reserve: inv?.reserve || 0,
                },
                feePercent: inv?.feePercent || 0,
              })) || [],
            })) || [],
            addedBy: loginUserUiid,
          },
        },
      });
      console.log({ response });
      if (response.success) {
        showToast("Report Submitted successfully!", "success");
        setFormData({
          ...initialFormData,
          fromDate: formData?.fromDate,
          toDate: formData?.toDate,
          reportPeriod: formData?.reportPeriod,
          search: formData?.search,
        });
        onClose();
        handleDashboardCalls();
      } else {
        showToast(`${response.error || "Something went wrong!"}`, "error");
      }
    } catch (error) {
      console.error("Error in handleUpload in Reserve Detail Report", error);
      showToast(`${error?.message || "Something went wrong!"} `, "error");
    }
  };
  const handleCancel = () => {
    setFormData({
      ...initialFormData,
      fromDate: formData.fromDate,
      toDate: formData.toDate,
      reportPeriod: formData.reportPeriod,
      search: formData.search,
    });
    onClose();
  };
  const handleDateRangeSelect = (val) => {
    handleChange("modalDate", val);

    if (val === "custom") {
      setIsCustomRange(true);
      handleChange("modalFromDate", null);
      handleChange("modalToDate", null);
      setResolvedRange({ from: null, to: null });
    } else {
      setIsCustomRange(false);

      const range = getDatesByOption(val);

      if (range) {
        handleChange("modalFromDate", range.from);
        handleChange("modalToDate", range.to);
        setResolvedRange(range);
      }
    }
  };

  const handleFromChange = (val) => {
    handleChange("modalFromDate", val);
    if (val && formData.modalToDate) {
      setResolvedRange({
        from: new Date(val),
        to: new Date(formData.modalToDate),
      });
    }
  };

  const handleToChange = (val) => {
    handleChange("modalToDate", val);
    if (formData.modalFromDate && val) {
      setResolvedRange({
        from: new Date(formData.modalFromDate),
        to: new Date(val),
      });
    }
  };

  const handlePreviewDateRangeSelect = (val) => {
    handleChange("modalPreviewDate", val);
    if (val === "custom") {
      setIsPreviewCustomRange(true);
      handleChange("modalPreviewFromDate", null);
      handleChange("modalPreviewToDate", null);
      setPreviewResolvedRange({ from: null, to: null });
    } else {
      setIsPreviewCustomRange(false);
      handleChange("modalPreviewFromDate", null);
      handleChange("modalPreviewToDate", null);
      const range = getDatesByOption(val);
      if (range) setPreviewResolvedRange(range);
    }
  };

  const handlePreviewFromChange = (val) => {
    handleChange("modalPreviewFromDate", val);
    if (val && formData.modalPreviewToDate) {
      setPreviewResolvedRange({
        from: new Date(val),
        to: new Date(formData.modalPreviewToDate),
      });
    }
  };

  const handlePreviewToChange = (val) => {
    handleChange("modalPreviewToDate", val);
    if (formData.modalPreviewFromDate && val) {
      setPreviewResolvedRange({
        from: new Date(formData.modalPreviewFromDate),
        to: new Date(val),
      });
    }
  };

  
  const handleUpload = async () => {
    try {
        if (formData?.modalReportName !== "Reserve Detail Report") {
          throw new Error("Please select an Reserve Detail Report option")
        }
        if (!formData?.modalFile?.[0]) {
          throw new Error("Please select a file")
        }
        if(!formData?.modalFromDate || !formData?.modalToDate) {
          throw new Error("Please select a date range")
        }
        // throw new Error("the object is invalid")
        const apiData = new FormData();
        apiData.append("coll", "Document");
        apiData.append("fileName", formData.modalReportName); 
        apiData.append("doc", formData.modalFile[0]);
        apiData.append("payload", JSON.stringify({
          range: {
            from: dayjs.utc(formData.modalFromDate).toISOString(),
            to: dayjs.utc(formData.modalToDate).toISOString(),
          },
        }));
        const response = await axiosRequest({
          method: "POST",
          url: ENDPOINTS.FUNDING_DASHBOARD.FILE_PARSE,
          data: apiData,
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
        // console.log({ response })
        if (response.success) {
          setUploadedFileModal(true);
          setRowsData(response?.data?.data || []);
          const agingdata = response?.data?.data?.map((row) => ({
            date: exactUTCDate(row?.date) || "",
            type: row?.type || "",
            description: row?.description || "",
            reference: row?.reference || "",
            rows: row?.invoices?.map((invoice) => ({
              invoiceNo: invoice?.invoiceNumber || "",
              reference: "",
              customer: invoice?.client || "",
              buyDate: dateFormator(invoice?.buyDate) || "",
              daysOpen: invoice?.daysOpen || "-",
              activityType: invoice?.activityType || "-",
              appliedAR: invoice?.ar || 0,
              appliedAdvance: invoice?.advance || 0,
              appliedFee: invoice?.fee || 0,
              feePct: invoice?.feePercent || 0,
              reserveAmount: invoice?.reserve || 0,
            })) || [],
            total: {
              appliedAR: row?.invoices?.map?.((invoice) => invoice?.ar || 0)?.reduce((a, b) => a + b, 0),
              appliedAdvance: row?.invoices?.map?.((invoice) => invoice?.advance || 0)?.reduce((a, b) => a + b, 0),
              appliedFee: row?.invoices?.map?.((invoice) => invoice?.fee || 0)?.reduce((a, b) => a + b, 0),
              reserveAmount: row?.invoices?.map?.((invoice) => invoice?.reserve || 0)?.reduce((a, b) => a + b, 0),
            },
          })) || []
          setRowsForParsedData(agingdata);
        } else {
          throw new Error(response.error);
        }
      } catch (error) {
        console.error("Error in handleUpload in Aging Report", error);
        showToast(`${error?.message || "Something went wrong!"} `, "error")
      }
    }
  
  return (
    <div>
      <div className="grid grid-cols-2 gap-4 mb-5">
        <FormFieldSet
          title="Report Name"
          type="select"
          placeholder="Select Report Name"
          options={reportOptions}
          onChange={(val) => handleChange("modalReportName", val)}
          value={formData.modalReportName}
        />

        <FormFieldSet
          title="Date Range"
          type="select"
          placeholder="Select Date Range"
          options={DATE_RANGE_OPTIONS}
          onChange={handleDateRangeSelect}
          value={formData.modalDate}
          // disabled={!formData.modalReportName || formData.modalReportName === "Aging Report"}
          disabled={!formData.modalReportName}
        />

        {formData?.modalDate && (
          <FormFieldSet
            title="From"
            type="datepicker"
            placeholder="select Date"
            onChange={handleFromChange}
            value={formData.modalFromDate}
            showDropdown={false}
            disabled={!isCustomRange}
          />
        )}

        {formData?.modalDate && (
          <FormFieldSet
            title="To"
            type="datepicker"
            placeholder="select Date"
            onChange={handleToChange}
            value={formData.modalToDate}
            showDropdown={false}
            minDate={
              formData.modalFromDate
                ? new Date(formData.modalFromDate)
                : undefined
            }
            disabled={!isCustomRange}
          />
        )}
      </div>

      <FileUploadNew
        title="Add Attachment"
        color="info"
        accept="all"
        maxFiles={5}
        onChange={(files) => handleChange("modalFile", files)}
        multiple
      />

      {/* ── Actions ── */}
      <div className="flex justify-end gap-3 mt-5">
        <Button title={"Cancel"} onClick={handleCancel} variant="outlined" />
        <Button title={"Upload"} onClick={handleUpload} />
      </div>

      <Modal
        isOpen={uploadedFileModal}
        onClose={() => setUploadedFileModal(false)}
        title="Reserved Detailed Report Preview"
        width="max-w-7xl"
        titleColor={"primary"}
      >
        <div>
          {/* <TableAdv
            columns={columns}
            showSlNo
            rows={filteredRows}
            totalCount={filteredRows?.length}
            page={page}
            limit={limit}
            onPaginationChange={setPage}
            onLimitChange={handleLimitChange}
            toolbarLeft={{
              search: false,
              filter: false,
              download: false,
              add: [
                {
                  component: (
                    <div className="flex gap-3 items-end mb-5 justify-center">
                      <div className="w-50">
                        <FormFieldSet
                          title="Date Range"
                          type="select"
                          size="sm"
                          placeholder="Select Date Range"
                          options={DATE_RANGE_OPTIONS}
                          onChange={handlePreviewDateRangeSelect}
                          value={formData.modalDate}
                        />
                      </div>

                      {isCustomRange && (
                        <div className="w-40">
                          <FormFieldSet
                            title="From"
                            size="sm"
                            type="datepicker"
                            placeholder="select Date"
                            onChange={handlePreviewFromChange}
                            value={formData.modalFromDate}
                            showDropdown={false}
                          />
                        </div>
                      )}

                      {isCustomRange && (
                        <div className="w-40">
                          <FormFieldSet
                            title="To"
                            size="sm"
                            type="datepicker"
                            placeholder="select Date"
                            onChange={handlePreviewToChange}
                            value={formData.modalToDate}
                            minDate={
                              formData.modalFromDate
                                ? new Date(formData.modalFromDate)
                                : undefined
                            }
                            showDropdown={false}
                          />
                        </div>
                      )}
                    </div>
                  ),
                },
              ],
            }}
          /> */}
          <div className="flex gap-3 items-end justify-start mb-3">
            <div className="min-w-40">
              <FormFieldSet
                title="Date Range"
                type="select"
                size="sm"
                placeholder="Select Date Range"
                options={DATE_RANGE_OPTIONS}
                onChange={() => {}}
                value={formData.modalDate}
                disabled
              />
            </div>

            {formData?.modalDate && (
              <div className="w-40">
                <FormFieldSet
                  title="From"
                  size="sm"
                  type="datepicker"
                  placeholder="select Date"
                  onChange={() => {}}
                  value={formData.modalFromDate}
                  showDropdown={false}
                  disabled
                />
              </div>
            )}

            {formData?.modalDate && (
              <div className="w-40">
                <FormFieldSet
                  title="To"
                  size="sm"
                  type="datepicker"
                  placeholder="select Date"
                  onChange={() => {}}
                  value={formData.modalToDate}
                  minDate={
                    formData.modalFromDate
                      ? new Date(formData.modalFromDate)
                      : undefined
                  }
                  showDropdown={false}
                  disabled
                />
              </div>
            )}
          </div>
          {/* <ReservedModalTable rows={rows} columns={columns} />*/}
          <ReservedModalTable rows={rowsForParsedData} columns={columns} />
        </div>
        <div className="flex justify-end gap-3 mt-5">
          <Button
            title={"Cancel"}
            onClick={() => setUploadedFileModal(false)}
            variant="outlined"
          />
          {/* <Button title={"Submit"} onClick={handleSubmit} disabled={true}/>*/}
          <Button title={"Submit"} onClick={handleSubmit}/>
        </div>
      </Modal>
    </div>
  );
};
export default ReservedUploadModal;
